import React, { useState } from 'react';

import { Modal, BlockStack, Select, TextField } from '@shopify/polaris';

const NewLoginCodeDialog = ({ locations, displayNewLoginCodeDialog, setDisplayNewLoginCodeDialog, createLoginCode, setSubmitted }) => {
  const [duration, setDuration] = useState(12);
  // Shopify fulfillments can ship from many locations - the admin picks
  // which one the code logs a warehouse user into
  const [locationId, setLocationId] = useState('');

  const enabledLocations = (locations.locations || []).filter((location) => location.enabled !== false);

  const create = () => {
    createLoginCode({ locationId: locationId, duration: duration * 3600 });
    setSubmitted(true);

    close();
  }

  const close = () => {
    setDuration(12);
    setLocationId('');

    setDisplayNewLoginCodeDialog(false);
  }

  return(
    <Modal
      open={displayNewLoginCodeDialog}
      onClose={() => close()}
      title="New Login Code"
      primaryAction={{
        content: 'New Login Code',
        onAction: () => create(),
        disabled: !locationId,
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: () => close()
        },
      ]}
    >
      <Modal.Section>
        <BlockStack gap="400">
          <Select
            label="Location"
            placeholder="Select a location"
            options={enabledLocations.map((location) => ({
              label: location.label,
              value: String(location.id)
            }))}
            value={locationId}
            onChange={setLocationId}
            requiredIndicator
          />

          <TextField
            label="Expires In (Hours)"
            value={String(duration)}
            onChange={(value) => setDuration(Number(value) || 0)}
            type="number"
            min={1}
            autoComplete="off"
            requiredIndicator
          />
        </BlockStack>
      </Modal.Section>
    </Modal>
  )
}

export default NewLoginCodeDialog;
